import { AfterViewInit, ChangeDetectorRef, Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { CommonService } from '@core/service/common.service';
import { FullPageLoaderComponent } from '@shared/full-page-loader/full-page-loader.component';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, FullPageLoaderComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  isLoading = signal<boolean>(false)
  constructor(
    private commonService: CommonService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.commonService.fullPageLoader$.subscribe((isLoading: boolean) => {
        this.isLoading.set(isLoading)
        this.cd.detectChanges();
      })
    }, 1);
  }
}
